import {
  COURSE_FILTER_SUCCESS,
  COURSE_LIST_SUCCESS,
  COURSE_INFO_SUCCESS,
  COURSE_UPDATE_SUCCESS,
  COURSE_FILTER_HANDLING,
  COURSE_SEARCH_NAME,
  CLEAR_COURSE_INFO,
  COURSE_LIST,
  COURSE_HARMONIZATION,
  COURSE_FAQ_LIST_SUCCESS,
  COURSE_FAQ_CREATE_SUCCESS,
  COURSE_FAQ_UPDATE_SUCCESS,
  COURSE_FAQ_DELETE_SUCCESS,
  COURSE_DECISION_BOX_SUCCESS,
  COURSE_DECISION_BOX_UPDATE_SUCCESS,
} from "../actionTypes/courses";
import {
  ON_SHOW_MESSAGE,
  INIT_URL,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
} from "../actionTypes/common";
import { userSignOut } from "./auth";
// import AllDataService from '../services/all.service';

import axiosHttp from "../services/axiosCommon";

export const getCourseFilter = () => async (dispatch) => {
  try {
    const promises = [
      axiosHttp.get("/v1/filtration"),
      axiosHttp.get("/v1/affiliation"),
      axiosHttp.get("/v1/courseType"),
      axiosHttp.get("/v1/category"),
      axiosHttp.get("/v1/mode"),
      axiosHttp.get("/v1/level"),
      axiosHttp.get("/v1/skill"),
    ];

    const response = await Promise.all(promises);
    const results = response.map((res) => res.data.status && res.data.results);
    console.log({ results });
    if (results.length === 0) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          message: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    } else {
      dispatch({
        type: ON_HIDE_LOADER,
      });
      dispatch({
        type: COURSE_FILTER_SUCCESS,
        payload: {
          ...results[0],
          affiliation: results[1] ? results[1] : [],
          courseType: results[2] ? results[2] : [],
          category: results[3] ? results[3] : [],
          mode: results[4] ? results[4] : [],
          level: results[5] ? results[5] : [],
          skills: results[6] ? results[6] : [],
          originalCategory: results[3] ? results[3] : [],
          originalAffiliation: results[1] ? results[1] : [],
          originalCourseType: results[2] ? results[2] : [],
        },
      });
    }
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          message: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const exportCourseCSV = (paramsObj) => async (dispatch) => {
  try {
    console.log("Export params:", paramsObj);
    const result = await axiosHttp.get("/v2/export", {
      params: paramsObj,
      headers: {
        Accept: "text/csv",
      },
      responseType: "blob",
    });
    const { data } = result;
    console.log("Export response:", data);
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};
export const getCourses = (paramsObj) => async (dispatch) => {
  try {
    const result = await axiosHttp.get("/courses/list", {
      params: paramsObj,
    });
    const { data } = result;
    if (data.error) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    } else {
      dispatch({
        type: COURSE_LIST,
        payload: data.data,
      });
    }

    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};
export const getCoursesList = (queryInfo) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    // Mapping queryInfo to v2 format
    const params = {
      ...queryInfo,
      page: (queryInfo.page || 1) - 1, // Frontend is 1-indexed, v2 is 0-indexed
      "sort-by": queryInfo["sort-by"] || queryInfo.sortByUpdatedAt || "rating:desc",
      sortByUpdatedAt: undefined, // Remove old param
    };

    const result = await axiosHttp.get("/v2/courses", {
      params: params,
    });
    const { data } = result;
    console.log({ responseData: data });

    if (!data.status && data.code !== 200) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    } else {
      // Mapping v2 response to what the reducer expects
      const results = data.results;
      const coursesData = results.courses;

      dispatch({
        type: COURSE_LIST_SUCCESS,
        payload: {
          data: coursesData.data,
          count: coursesData.total,
          pages: coursesData.totalPages,
          page: coursesData.page + 1, // Map back to 1-indexed for frontend
          queryInfo: {
            ...queryInfo,
            page: coursesData.page + 1,
            "sort-by": params["sort-by"],
          },
        },
      });
    }

    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    // ... rest of error handling remains the same
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};
export const getCourseInfo = (courseId) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const result = await axiosHttp.get("/v1/course/" + courseId, {
      validateStatus: (status) => status < 405,
    });
    const { data } = result;
    if (!data.status) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    } else {
      dispatch({
        type: ON_HIDE_LOADER,
      });
      // dispatch({
      //   type: COURSE_INFO_SUCCESS,
      //   payload: data,
      // });

      dispatch({
        type: COURSE_INFO_SUCCESS,
        payload: data.results,
      });
    }

    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      // dispatch(
      //   userSignOut({
      //     changeMessage: true,
      //     payload: {
      //       message: response.data.message,
      //       status: response.status,
      //       error: true,
      //     },
      //   })
      // );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          message: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};
export const setCoursesInfo = (info) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  dispatch({
    type: COURSE_INFO_SUCCESS,
    payload: info,
  });
};
export const createCourses = (infoData) => async (dispatch) => {
  console.log({ infoData });
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const result = await axiosHttp.post("/v1/course", infoData);
    const { data } = result;
    if (!data.status) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      return Promise.reject(data);
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      return Promise.resolve(data);
    }
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};
export const courseImport = (infoData) => async (dispatch) => {
  console.log({ infoData });
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    console.log({ axiosHttp });
    const result = await axiosHttp.post("/v1/importData", infoData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      // responseType: "blob",
    });
    const { data } = result;
    return Promise.resolve(data);
    // if (data.error) {
    //   dispatch({
    //     type: ON_SHOW_MESSAGE,
    //     payload: data,
    //   });
    //   return Promise.reject(data);
    // } else {
    //   dispatch({
    //     type: ON_SHOW_MESSAGE,
    //     payload: data,
    //   });
    //   dispatch({
    //     type: COURSE_CREATE_SUCCESS,
    //     payload: { ...data.data },
    //   });
    //   dispatch({
    //     type: HIDE_DIALOG,
    //   });
    //   return Promise.resolve(data);
    // }
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};
export const updateCourses = (infoData, queryInfo) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  const { courseId } = infoData;
  try {
    const result = await axiosHttp.put("/v1/course/" + courseId, infoData);
    const { data } = result;
    if (!data.status) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      return Promise.reject(data);
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      dispatch({
        type: COURSE_UPDATE_SUCCESS,
        payload: infoData,
      });
      dispatch({ type: INIT_URL, payload: "/course/list" });
      return Promise.resolve(infoData);
    }
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};
export const deleteCourses = (infoData) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const { courseId, queryInfo, status } = infoData;
    const result = await axiosHttp.put("/v1/course/" + courseId, { status });
    // const result = await axiosHttp.delete("/courses", infoData);
    const { data } = result;
    if (data.error) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    } else {
      // dispatch({
      //   type: INIT_URL,
      //   payload: "/coursess/list",
      // });
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      dispatch(getCoursesList(queryInfo));
    }

    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const onChangeSearchName = (info) => async (dispatch) => {
  dispatch({
    type: COURSE_SEARCH_NAME,
    payload: info,
  });
};

export const onChangeFilterHandling = (info) => async (dispatch) => {
  dispatch({
    type: COURSE_FILTER_HANDLING,
    payload: info,
  });
};
export const clearCoursesInfo = () => async (dispatch) => {
  dispatch({
    type: CLEAR_COURSE_INFO,
  });
};

export const harmonizationCourses = (infoData) => async (dispatch) => {
  try {
    // const { type, idFrom, idTo } = infoData;
    const result = await axiosHttp.post("v1/harmonization", infoData);
    const { data } = result;
    if (data.error) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    } else {
      dispatch({
        type: COURSE_HARMONIZATION,
        payload: data.data,
      });
    }

    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const getCourseFaqs = (courseId) => async (dispatch) => {
  console.log("getCourseFaqs called with ID:", courseId);
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const url = `/v2/courses/${courseId}/contents/faqs`;
    console.log("Requesting URL:", url);
    const result = await axiosHttp.get(url);
    const { data } = result;
    if (data.status) {
      dispatch({
        type: COURSE_FAQ_LIST_SUCCESS,
        payload: data.results || [], 
      });
      dispatch({
        type: ON_HIDE_LOADER,
      });
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    }
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    dispatch({
      type: ON_HIDE_LOADER,
    });
    // Treat 404 as "no FAQs yet" - this is expected for courses without FAQs
    if (response && response.status === 404) {
      console.log("No FAQs found for this course (404). Treating as empty list.");
      dispatch({
        type: COURSE_FAQ_LIST_SUCCESS,
        payload: [],
      });
      return Promise.resolve({ status: true, results: [] });
    }
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response ? response.data?.message : "Some error has occurred",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const createCourseFaq = (courseId, faqData) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const result = await axiosHttp.post(`/v2/courses/${courseId}/contents/faqs`, faqData);
    const { data } = result;
    if (data.status) {
      dispatch({
        type: COURSE_FAQ_CREATE_SUCCESS,
        payload: data.results,
      });
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "FAQ Created Successfully",
          status: 200,
          error: false,
        },
      });
      dispatch({
        type: ON_HIDE_LOADER,
      });
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    }
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response ? response.data.message : "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const updateCourseFaq = (courseId, faqId, faqData) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const result = await axiosHttp.put(`/v2/courses/${courseId}/contents/faqs/${faqId}`, faqData);
    const { data } = result;
    if (data.status) {
      dispatch({
        type: COURSE_FAQ_UPDATE_SUCCESS,
        payload: data.results,
      });
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "FAQ Updated Successfully",
          status: 200,
          error: false,
        },
      });
      dispatch({
        type: ON_HIDE_LOADER,
      });
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    }
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response ? response.data.message : "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const deleteCourseFaq = (courseId, faqId) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const result = await axiosHttp.delete(`/v2/courses/${courseId}/contents/faqs/${faqId}`);
    const { data } = result;
    if (data.status) {
      dispatch({
        type: COURSE_FAQ_DELETE_SUCCESS,
        payload: faqId,
      });
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "FAQ Deleted Successfully",
          status: 200,
          error: false,
        },
      });
      dispatch({
        type: ON_HIDE_LOADER,
      });
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    }
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response ? response.data.message : "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const getCourseDecisionBox = (courseId) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const url = `/v2/courses/${courseId}/contents/decision-box`;
    const result = await axiosHttp.get(url);
    const { data } = result;
    if (data.status) {
      dispatch({
        type: COURSE_DECISION_BOX_SUCCESS,
        payload: data.results,
      });
      dispatch({
        type: ON_HIDE_LOADER,
      });
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    }
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    dispatch({
      type: ON_HIDE_LOADER,
    });
    // Treat 404 as empty if not found
    if (response && response.status === 404) {
      dispatch({
        type: COURSE_DECISION_BOX_SUCCESS,
        payload: {},
      });
      return Promise.resolve({ status: true, results: {} });
    }

    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response ? response.data.message : "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const saveCourseDecisionBox = (courseId, data) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const url = `/v2/courses/${courseId}/contents/decision-box`;
    const result = await axiosHttp.put(url, data);
    const { data: resData } = result;

    if (resData.status) {
      dispatch({
        type: COURSE_DECISION_BOX_UPDATE_SUCCESS,
        payload: { ...data, ...(resData.results || {}) },
      });
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Decision Box Saved Successfully",
          status: 200,
          error: false,
        },
      });
      dispatch({
        type: ON_HIDE_LOADER,
      });
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: resData,
      });
    }
    return Promise.resolve(resData);
  } catch (err) {
    const { response } = err;
    dispatch({
      type: ON_HIDE_LOADER,
    });

    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response ? response.data.message : "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const saveCourseSkills = (courseId, skills) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const result = await axiosHttp.put("/v1/course/" + courseId, { skills });
    const { data } = result;
    if (data.status) {
      // Update courseInfo in store with new skills
      dispatch({
        type: COURSE_INFO_SUCCESS,
        payload: { ...data.results },
      });
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Skills Saved Successfully",
          status: 200,
          error: false,
        },
      });
      dispatch({
        type: ON_HIDE_LOADER,
      });
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    }
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    dispatch({
      type: ON_HIDE_LOADER,
    });

    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response ? response.data?.message : "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const saveCourseLevel = (courseId, levelAiData) => async (dispatch) => {
  dispatch({
    type: ON_SHOW_LOADER,
  });
  try {
    const result = await axiosHttp.put("/v1/course/" + courseId, { level_ai: levelAiData });
    const { data } = result;
    if (data.status) {
      dispatch({
        type: COURSE_INFO_SUCCESS,
        payload: { ...data.results },
      });
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "AI Level Saved Successfully",
          status: 200,
          error: false,
        },
      });
      dispatch({
        type: ON_HIDE_LOADER,
      });
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
    }
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    dispatch({
      type: ON_HIDE_LOADER,
    });

    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data.message,
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response ? response.data?.message : "Some error has occurred",
          status: 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const getCoursePriceHistory = (courseId, days = 90) => async (dispatch) => {
  try {
    const result = await axiosHttp.get(`/v2/courses/${courseId}/price-history`, {
      params: { days },
    });
    const { data } = result;
    const isSuccess = data.success ?? data.status;
    const payload = data.data ?? data.results;

    if (!isSuccess) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      return Promise.reject(data);
    }
    // Return the full payload containing both history[] and stats{}
    return Promise.resolve(payload || {});
  } catch (err) {
    console.error("Error fetching price history:", err);
    return Promise.reject(err);
  }
};

export const getRelatedCourses = (courseId, compareBy = "price") => async (dispatch) => {
  try {
    const result = await axiosHttp.get(`/v2/courses/${courseId}/related`, {
      params: { compareBy },
    });
    const { data } = result;
    const isSuccess = data.success ?? data.status;
    const payload = data.data ?? data.results;

    if (!isSuccess) {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: data,
      });
      return Promise.reject(data);
    }
    return Promise.resolve(payload?.courses || []);
  } catch (err) {
    console.error("Error fetching related courses:", err);
    return Promise.reject(err);
  }
};
